import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { CopyIcon, CallOutlinedIcon } from '$common/icons'
import { PopupMenuItem, PopupMenuList } from '$common/popup-menu'
import { showPhoneNumberSavedInMemorySnackbar } from '$comp/snackbars'
import { copyToClipboard } from '$func/clipboard'
import { t } from '$i18n'

interface Props {
  phone: string
  isOpen: boolean
}

export function PhoneMenu({ phone, isOpen }: Props) {
  return (
    <PopupMenuList open={isOpen}>
      <PopupMenuItem
        text={t('menu.common.copy')}
        onClick={async () => {
          copyToClipboard(phone)
          await closeCurrentModal()
          showPhoneNumberSavedInMemorySnackbar()
        }}
      >
        <CopyIcon />
      </PopupMenuItem>

      <PopupMenuItem
        text={t('menu.phone.call')}
        onClick={async () => {
          await closeCurrentModal()
          window.open(`tel:${phone}`)
        }}
      >
        <CallOutlinedIcon />
      </PopupMenuItem>
    </PopupMenuList>
  )
}
